const BPWEl = document.getElementById('BPWProductAccordion')
const BPWItem = {
    components: {
        'currency': ProductGridPrice
    },
    props: {
        item: Object
    },
    emits: ['addToCart','openNotifyModal'],
    data() {
        return {
            selectedVariant: this.item.variants[0]
        }
    },
    computed: {
        orderVariants() {
            return this.item.variants.filter(v => v.found === true)
        },
    },
    methods: {
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(amount/100);
        },
        addToCart() {
            if(this.item.variants.length > 1 && !this.selectedVariant) {
                return false;
            }
            this.$emit('addToCart', 1, this.selectedVariant.id, this.item);
        },
        notifyMe() {
            this.openNotifyModal();
        },
        openNotifyModal() {
            const variantId = this.selectedVariant ? this.selectedVariant.id : this.item.selected_or_first_available_variant;
            this.$emit('openNotifyModal',variantId);
        }
    },
    template: `<div class="row">
                <div class="col-4 col-image">
                    <a :href="item.url" target="_blank"><img :src="item.img_url" alt="" loading="lazy"></a>
                </div>
                <div class="col-8 col-contents">
                    <a :href="item.url" target="_blank" v-html="item.title"></a>
                    <p>{{item.description}} <a :href="item.url" target="_blank">Learn more</a>
                    </p>
                    <div class="upsell-grid-actions">
                      <a v-if="item.disable_atc" class="button button--full-width button--primary" :href="item.url">
                        <span>Create Your Set ></span>
                      </a>
                      <button v-else-if="selectedVariant.available" type="button" class="button button--full-width button--primary" :class="{loading: item.loading}" @click.stop="addToCart">
                        <span>Add to cart</span>
                        <span class="loading-overlay__spinner" :class="{hidden: !item.loading}">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                        </span>
                        <div class="upsell-price">
                            <div class="price">
                                <div class="price__container">&nbsp;
                                    <span v-if="selectedVariant.compare_at_price > selectedVariant.price"><s>{{formatCurrency(selectedVariant.compare_at_price)}}</s>&nbsp;</span>
                                    <span>{{formatCurrency(selectedVariant.price)}}</span>
                                </div>
                            </div>
                        </div>
                      </button>
                      <button v-else type="button" class="button button--full-width button--primary" @click.stop="notifyMe">
                        <span>Notify Me</span>
                        <span class="loading-overlay__spinner" :class="{hidden: !item.loading}">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                        </span>
                      </button>
                      <select :name="'upsell-id['+item.id+']'" :id="'productSelect-'+item.id" v-if="!item.has_only_default_variant && orderVariants.length > 0" v-model="selectedVariant">
                        <option v-for="variant in orderVariants" :value="variant">{{ variant.variant_size ?? variant.product_size ?? variant.title }}</option>
                      </select>
                    </div>
                </div>
            </div>`
}
const BPWApp = Vue.createApp({
    components: {
        'product': BPWItem,
        'currency': ProductGridPrice,
        'notify': NotifyMeModal,
    },
    props: ['heading'],
    data() {
        return {
            products: [],
            i18n: {},
            cartAddUrl: '/cart/add.js',
            showModal: false,
            showNotify: false,
            modalLoading: false,
            notifyLoading: false,
            notifySuccess: false,
            notifyItem: null,
            quickViewItem: {},
            quickViewItems: {}
        }
    },
    created() {
        this.fetchHeaders = new Headers();
        this.fetchHeaders.append('pragma', 'no-cache');
        this.fetchHeaders.append('cache-control', 'no-store');
        this.fetchHeaders.append('Content-Type', 'application/json');
        this.cartNotification = document.querySelector('cart-notification');
        try {
            // load Best Paired With products
            let data = JSON.parse(document.getElementById('BPW-data').innerText);
            this.updateLocations(data).then(() => {
                data = data.filter(product => product.found === true);
                data.sort((a,b) => b.available - a.available);
                this.products = data;
            });
        } catch (e) {
            console.error(e);
        }
        if(window.evanhealy_settings && window.evanhealy_settings.i18n) {
            this.i18n = window.evanhealy_settings.i18n;
        }
    },
    methods: {
        addToCart(qty,variantId,gridItem) {
            const data = {
                items: []
            };
            const item = {id: variantId, quantity: qty};
            data.items.push(item);
            const body = JSON.stringify(data);
            this.modalLoading = true;
            this.products.forEach((product) => {
                if(product.id === gridItem.id) {
                    product.loading = true;
                }
            });
            fetch(this.cartAddUrl,{method: 'POST', headers: this.fetchHeaders , body})
                .then((response) => {
                    this.showModal = false;
                    this.modalLoading = false;
                    this.updateCart(response);
                })
                .catch((e) => {
                    console.error(e);
                }).finally(() => {
                this.modalLoading = false;
                this.products.forEach((product) => {
                    product.loading = false;
                });
            });
        },
        updateCart(response) {
            const event = new CustomEvent("ehAddProductToCart", {detail: response});
            window.dispatchEvent(event);
            this.cartNotification.renderContents(response);
        },
        openNotifyModal(item) {
            document.body.classList.add('overflow-hidden');
            this.showNotify = true;
            this.notifyItem = item;
        },
        submitNotify(email,variantId) {
            if(!email || !variantId) {
                return false;
            }
            this.notifyLoading = true;
            backInStockSubscription(email,variantId)
                .then((response) => {
                    this.notifySuccess = true;
                    this.notifyLoading = false;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.notifyLoading = false;
                });
        },
    },
    template: `
        <div class="product__accordion accordion" v-if="products.length > 0">
            <details open>
              <summary style="pointer-events: none;">
                <h2 class="h4 accordion__title">{{heading || 'Best Paired With'}}</h2>
              </summary>
              <div class="accordion__content rte">
                <div class="upsell-grid">
                    <div class="item" v-for="(product, index) in products" :key="product.id">
                        <product
                         :item="product"
                         @add-to-cart="addToCart"
                         @open-notify-modal="openNotifyModal"
                        ></product>
                    </div>
                </div>
              </div>
            </details>
        </div>
        <notify v-if="products.length > 0" :show="showNotify" :loading="notifyLoading" :submitted="notifySuccess" :item="notifyItem" @submit-notify="submitNotify" @close="showNotify = false; notifySuccess = false;"></notify>`
}, { ...BPWEl.dataset })
BPWApp.use(ehPlugin);
BPWApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api')
BPWApp.config.unwrapInjectedRef = true
BPWApp.mount('#BPWProductAccordion')
